import { TitleProps } from "./Title.types";
import { defaultProps } from "./Title.types";
import styles from "./Title.module.scss";
import cx from "classnames";

export const Title = (props: TitleProps) => {
	const { content, tag, color, className, ...attributes } = { ...defaultProps, ...props };

	const CustomTag = tag as keyof Pick<JSX.IntrinsicElements, "h1" | "h2" | "h3" | "h4" | "h5" | "h6">;

	return (
		<CustomTag
			{...attributes}
			className={cx(
				styles.Title,
				color === "black" && styles.black,
				color === "green" && styles.green,
				className
			)}
		>
			{content}
		</CustomTag>
	);
}
